import {Router} from '@angular/router';
import {Injectable, NgZone} from '@angular/core';
import {AuthService} from "./auth.service";
import {GlobalConstants} from "../constants/global-constants";

const MINUTES_UNITL_AUTO_LOGOUT = 30 // in Minutes
const CHECK_INTERVALL = 60000 // in ms
const STORE_KEY = GlobalConstants.lastActionStorageKey;

/**
 * Service records the users last mouse click, if no click within MINUTES_UNITL_AUTO_LOGOUT
 * the user is automatically logged out.
 * This service is used ONLY within the header component as this is rendered on all pages where a user is authenticated
 */
@Injectable()
export class AutoLogoutService {

  constructor(
    private router: Router,
    private ngZone: NgZone,
    private authService: AuthService
  ) {
    // Seed only when nothing is recorded yet. Without this the very first check() read
    // NaN and every comparison against NaN is false, so the timeout could not fire until
    // some later click happened to write the key (AB#34659). Seeding only when absent
    // keeps a genuinely stale timestamp from earlier in this tab counting against the user.
    if (isNaN(this.lastAction)) {
      this.reset();
    }

    this.check();
    this.initListener();
    this.initInterval();
  }

  get lastAction() {
    return parseInt(sessionStorage.getItem(STORE_KEY));
  }
  set lastAction(value) {
    sessionStorage.setItem(STORE_KEY, value.toString());
  }

  initListener() {
    this.ngZone.runOutsideAngular(() => {
      document.body.addEventListener('click', () => this.reset());
    });
  }

  initInterval() {
    this.ngZone.runOutsideAngular(() => {
      setInterval(() => {
        this.check();
      }, CHECK_INTERVALL);
    })
  }

  reset() {
    this.lastAction = Date.now();
  }

  check() {
    const lastAction = this.lastAction;

    // Session storage can be cleared underneath us. Restart the clock rather than
    // comparing against NaN, which would silently disable the timeout for good.
    if (isNaN(lastAction)) {
      this.reset();
      return;
    }

    const now = Date.now();
    const timeleft = lastAction + MINUTES_UNITL_AUTO_LOGOUT * 60 * 1000;
    const diff = timeleft - now;
    const isTimeout = diff < 0;

    this.ngZone.run(() => {
      if (isTimeout) {
        this.authService.logout(true);
      }
    });
  }
}
